import React, { useState, useRef, useEffect } from 'react';
import { Lightbox } from "react-modal-image";

import Config from "src/config";
import { Box, IconButton, Stack } from '@mui/material';
//import './Messages.css';
import { useDispatch, useSelector } from "react-redux";

import useAuth from 'src/hooks/useAuth';
import ChatInternoMessageItem from './ChatInternoMessageItem';
import { Input } from 'src/@/components/ui/input';
import { Button } from 'src/@/components/ui/button';
import { Avatar } from '@mui/material';
//import getMoreMessages from "../../../actions/getMoreMessages";

import ReactImageAppear from 'react-image-appear';
import Iconify from 'src/components/Iconify';
import { convertUrls } from 'src/utils/functions';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionChatInternoDeletarMsg from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoDeletarMsg';
import SkeletonChatWindow from 'src/components/skeleton/chats/SkeletonChatWindow';
import LightboxModal from 'src/components/LightboxModal';
import v2_actionChatInternoMensagens from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoMensagens';
import { setMessageDeleted } from 'src/redux/slices/staff';



const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, message) => {
    const date = new Date(message.date).toLocaleDateString();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(message);
    return acc;
  }, {});
};


const ChatMessageItem = ({ msg, user, index, onDelete, onReply, isMiniChat, onOpen }) => {
  return (
    <ChatInternoMessageItem
      isMiniChat={isMiniChat}
      key={index}
      message={msg}
      previous={msg[index - 1]}
      next={msg[index + 1]}
      onOpen={onOpen}
      onDelete={onDelete}
      onReply={onReply}
    />
  )
}



const ListMessages = ({
  mensagens,
  user,
  ref,
  onReply,
  onDelete,
  selectedMessage,
  closeReplyMsg,
  isMiniChat,
  onOpen
}) => {

  let fullMsgs = mensagens;

  const groupedMessages = groupMessagesByDate(mensagens);

  return (
    <div ref={ref} className="flex flex-col min-h-full x-auto p-4">

      <div className="overflow-auto flex-1">
        {Object.keys(groupedMessages).map((date) => (
          <div key={date}>
            <div className='w-full flex justify-center'>
              <div className=" p-2 bg-slate-100 shadow-sm rounded-lg text-xs font-bold text-slate-500">{date}</div>

            </div>
            {groupedMessages[date].map((msg, index) => (
              <ChatMessageItem
                isMiniChat={isMiniChat}
                msg={msg}
                user={user}
                index={index}
                onDelete={onDelete}
                onReply={onReply}
                onOpen={onOpen}
              />
            ))}
          </div>
        ))}



      </div>

      {!!selectedMessage && (
        <div
          class="p-4 flex flex-row bg-slate-100 border-slate-200 rounded border items-center justify-center">
          <div class="content flex-1 flex items-center justify-center">
            <ChatMessageItem
              msg={selectedMessage}
              user={user}
              index={1}
            />
          </div>
          <Button onClick={closeReplyMsg}>
            <Iconify icon="material-symbols:close" className="icon-arrow-up" />
          </Button>
        </div>
      )}

    </div>
  );
};

const ChatInternoMessagesList = ({ isMiniChat, onReply, onOpen }) => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { mensagensStaff, staff } = useSelector((state) => state.staff);
  const [listaMoreMsgs, setListaMoreMsgs] = useState([]);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [messageIdDelete, setMessageIdDelete] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loadingDeleteMsg, setLoadingDeleteMsg] = useState(null);


  let msgs = mensagensStaff;
  if (isMiniChat) {
    const chatSession = JSON.parse(sessionStorage.getItem('chatInternoMiniId'));
    if (chatSession) {
      msgs = chatSession?.messages;
    }
  }
  const mensagens = msgs;
  const chat = useRef(null);
  const [open, setOpen] = useState(null);

  // eslint-disable-next-line no-unused-vars
  let other = {
    firstName: 'A', lastName: 'A'
  };

  if (!staff.isGroup && staff.people) {
    staff.people.forEach(person => {
      if (person._id !== user.id) other = person;
    });
  }


  async function getMoreMsgs() {
    try {
      let querys = `?limit=10&skip=0&msgs=1`;
      const result = await v2_actionChatInternoMensagens(staff._id, querys);
      if (result.status === 200) {
        setListaMoreMsgs(prev => [...prev, ...result.data.data]);
      }
    } catch (error) {
      console.log(error);
    }
  }


  // const onScroll = () => {
  //   if (chat?.current?.scrollTop === 0) {
  //     if (loading) return;
  //     setLoading(true);
  //     alert('loading more messages');
  //     // getMoreMessages({roomID: room._id, firstMessageID: messages[0]._id}).then(res => {
  //     //     console.log(res.data.messages)
  //     //     // dispatch({type: Actions.MORE_MESSAGES, messages: res.data.messages});
  //     //     setLoading(false);
  //     // }).catch(err => {
  //     //     setLoading(false);
  //     // });
  //   }
  // };

  useEffect(() => {
    chat.current.scrollTop = chat.current.scrollHeight;
}, [mensagens.length]);


  async function handleDeleteMsg() {
    setLoading(true);
    try {
      console.log('messageIdDelete', messageIdDelete);
      await v2_actionChatInternoDeletarMsg(messageIdDelete);
      setMessageIdDelete(null);
      dispatch(setMessageDeleted(messageIdDelete));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error)
    }
    setOpenModalConfirmacao(false);
  }

  return (
    <div
      className="p-4 flex-1 overflow-y-auto"
      ref={chat}
    //  onScroll={onScroll}
    >
      <Stack justifyContent={'center'} alignItems={'center'}>
        <IconButton style={{ cursor: "pointer", backgroundColor: '#fff', color: "#0aafd9", fontSize: "20px" }} >
          <Iconify icon="material-symbols:refresh" />
        </IconButton>
      </Stack>
      <ModalConfimacao
        open={openModalConfirmacao}
        onClose={() => {
          setOpenModalConfirmacao(false);
          setMessageIdDelete(null);
        }}
        onConfirm={handleDeleteMsg}
        loadingFinalizar={loadingDeleteMsg}
        mensagem={'Deseja mesmo excluir essa mensagem?'}
      />

      <div className="">
        {open && (
          // <LightboxModal
          //  clickedUrl={`${Config.urlWs || ''}/api/files/${open.content}`}
          //   medium={`${Config.urlWs || ''}/api/files/${open.content}`}
          //   large={`${Config.urlWs || ''}/api/files/${open.content}`}
          //   alt="Lightbox"
          //   hideDownload={false}
          //   onClose={() => setOpen(null)}
          // />
          <LightboxModal
            images={`${Config.urlWs || ''}/api/files/${open.content}`}
            photoIndex={0}
            mainSrc={`${Config.urlWs || ''}/api/files/${open.content}`}
            setPhotoIndex={() => { }}
            isOpen={open}
            download={() => baixarMidiaDevice()}
            onClose={() => {
              setOpen(null);
              // setIsDownloadImage(true);
              // setClickedUrl("");
            }}
          />
        )}


        <ListMessages
          isMiniChat={isMiniChat}
          selectedMessage={selectedMessage}
          mensagens={mensagens}
          user={user}
          onOpen={setOpen}
          onReply={onReply}
          onDelete={value => {
            console.log('ondelete', value);
            setOpenModalConfirmacao(true);
            setMessageIdDelete(value);
          }}
        />


      </div>
    </div>
  );
};

export default ChatInternoMessagesList;
